// extracted by mini-css-extract-plugin
export default {"iconBack":"buttonBack_iconBack__rY-to"};